import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Pharmacy } from '@enums/pharmacies';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the GLP-1 Renewal treatment type.
 */
export const Glp1RenewalTreatment = new TreatmentType({
  id: '10',
  name: ConsultationTreatmentTypes.Glp1Renewal,
  restrictedStates: ['AL', 'AR', 'LA', 'MS', 'NC', 'ND', 'VA'],
  restrictedStatesError: 'Starfish.com does not offer GLP-1 in your state at this time.',
  designatedPharmacyId: Pharmacy.CASA_PHARMA,
  eligibleTreatmentTypes: [
    {
      id: 3164,
      name: UpsellSlugs.SemaglutideInjectable0_5mg,
    },
    {
      id: 3165,
      name: UpsellSlugs.SemaglutideInjectable1mg,
    },
    {
      id: 3166,
      name: UpsellSlugs.SemaglutideInjectable1_7mg,
    },
    {
      id: 3168,
      name: UpsellSlugs.SemaglutideInjectable2_5mg,
    },
    {
      id: 3706,
      name: UpsellSlugs.SemaglutideOral5mg,
    },
    {
      id: 3707,
      name: UpsellSlugs.SemaglutideOral12mg,
    },
    {
      id: 3169,
      name: UpsellSlugs.TirzepatideInjectable5mg,
    },
    {
      id: 3170,
      name: UpsellSlugs.TirzepatideInjectable7_5mg,
    },
    {
      id: 3171,
      name: UpsellSlugs.TirzepatideInjectable10mg,
    },
    {
      id: 3172,
      name: UpsellSlugs.TirzepatideInjectable12_5mg,
    },
    {
      id: 3173,
      name: UpsellSlugs.TirzepatideInjectable15mg,
    },
    {
      id: 3709,
      name: UpsellSlugs.TirzepatideOral4mg,
    },
    {
      id: 3710,
      name: UpsellSlugs.TirzepatideOral5mg,
    },
  ],
});
